<template>

  <section class="max-w-3xl mx-auto px-4 py-16">
    <h1 class="text-2xl sm:text-3xl md:text-4xl
         font-extrabold font-serif tracking-tight
         text-teal-700 mb-4 text-center">
      Book Your Dental Appointment Today
    </h1>

    <!-- Instant Contact Options -->
    <div class="mb-10 bg-teal-50 border border-teal-100 rounded-2xl p-6 text-center">
      <h2 class="text-xl font-semibold text-teal-700 mb-2">
        Call or WhatsApp us for faster confirmation
      </h2>
      <p class="text-sm text-gray-600 mb-6">

      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <!-- Call Button -->
        <a href="tel:+918638940021" class="flex items-center justify-center gap-2
             bg-teal-600 text-white px-6 py-3
             rounded-full font-medium hover:bg-teal-700 transition">
          📞 Call Clinic
        </a>

        <!-- WhatsApp Button -->
        <button
  type="button"
  @click="openWhatsApp"
  class="flex items-center justify-center gap-2
         bg-green-500 text-white px-6 py-3
         rounded-full font-medium hover:bg-green-600 transition"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    class="w-5 h-5 fill-current"
  >
    <path d="M16 2.67C8.64 2.67 2.67 8.64 2.67 16c0 2.6.77 5.13 2.22 7.29L2 30l6.88-2.74A13.24 13.24 0 0 0 16 29.33c7.36 0 13.33-5.97 13.33-13.33C29.33 8.64 23.36 2.67 16 2.67zm0 24.32c-2.31 0-4.57-.62-6.52-1.79l-.47-.28-4.08 1.62 1.63-3.97-.3-.5a11.17 11.17 0 1 1 9.74 4.92z"/>
    <path d="M19.11 17.06c-.28-.14-1.65-.81-1.9-.9-.26-.09-.45-.14-.64.14-.19.28-.74.9-.91 1.08-.17.19-.33.21-.61.07-.28-.14-1.18-.43-2.24-1.38-.83-.74-1.39-1.65-1.56-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.33.43-.5.14-.17.19-.28.28-.47.09-.19.05-.36-.02-.5-.07-.14-.64-1.54-.88-2.11-.23-.55-.47-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.28-1 1-1 2.44s1.03 2.83 1.17 3.03c.14.19 2.03 3.1 4.92 4.35.69.3 1.23.48 1.65.61.69.22 1.32.19 1.82.11.56-.08 1.65-.67 1.88-1.32.23-.64.23-1.19.16-1.32-.07-.13-.26-.21-.54-.35z"/>
  </svg>

  WhatsApp Us
</button>



      </div>
    </div>

    <!-- Divider -->
    <!-- <div class="flex items-center gap-4 my-8">
      <div class="flex-1 h-px bg-gray-200"></div>
      <span class="text-sm text-gray-500 uppercase tracking-wide">
        Or book online
      </span>
      <div class="flex-1 h-px bg-gray-200"></div>
    </div> -->

    <!-- <form @submit.prevent="handleSubmit" class="space-y-6 bg-white p-8 rounded-lg shadow-lg">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label class="block mb-2 text-gray-700 font-medium">Full Name</label>
          <input type="text" v-model="form.name" class="w-full input" required />
        </div>
        <div>
          <label class="block mb-2 text-gray-700 font-medium">Phone Number</label>
          <input type="tel" v-model="form.phone" class="w-full input" required />
        </div>
        <div>
          <label class="block mb-2 text-gray-700 font-medium">Preferred Date</label>
          <input type="date" v-model="form.date" class="w-full input" required />
        </div>
        <div>
          <label class="block mb-2 text-gray-700 font-medium">
            Preferred Time
          </label>
          <input type="time" v-model="form.time" class="w-full input" required />
        </div>

      </div>

      <div>
        <label class="block mb-2 text-gray-700 font-medium">Message</label>
        <textarea v-model="form.message" class="w-full input" rows="4"
          placeholder="Let us know your concern..."></textarea>
      </div>

      <button type="submit" :disabled="isSubmitting"
        class="bg-teal-600 text-white px-6 py-3 rounded-full hover:bg-teal-700 transition w-full">
        <span v-if="!isSubmitting">📨 Submit</span>
        <span v-else>⏳ Sending...</span>
      </button>

      <p v-if="submissionMessage" :class="{ 'text-green-600': success, 'text-red-500': !success }"
        class="text-sm text-center mt-4">
        {{ submissionMessage }}
      </p>
    </form> -->
  </section>
</template>


<script>
import { useHead } from "@vueuse/head";

export default {
  setup() {
    useHead({
      title: "Book Dental Appointment in Guwahati | Magnum Dental Clinic",
      meta: [
        {
          name: "description",
          content:
            "Book your dental appointment at Magnum Dental Clinic Guwahati. Call or WhatsApp +91 8638940021. We offer flexible appointment slots Mon–Sun, 9:30 AM–7:30 PM.",
        },
        {
          name: "robots",
          content: "index, follow",
        },
        {
          property: "og:title",
          content: "Book Dental Appointment in Guwahati | Magnum Dental Clinic",
        },
        {
          property: "og:url",
          content: "https://www.magnumdentalguwahati.in/book-appointment-dental-clinic-guwahati",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.magnumdentalguwahati.in/book-appointment-dental-clinic-guwahati" },
      ],
    });
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        email: '',
        date: '',
        time: '',
        message: ''
      },
      isSubmitting: false,
      submissionMessage: '',
      success: false
    };
  },
  methods: {
    handleSubmit() {
      const now = Date.now();
      const lastSubmit = localStorage.getItem("lastAppointmentSubmit");
      const cooldown = 1 * 60 * 1000; // 1 minute

      if (lastSubmit && now - Number(lastSubmit) < cooldown) {
        this.submissionMessage = "Appointment successfully booked. Our representative will contact you shortly to confirm the details.";
        this.success = false;
        return;
      }

      this.isSubmitting = true;
      this.submissionMessage = "";

      // Simulate sending process (2 seconds)
      setTimeout(() => {
        this.isSubmitting = false;
        this.success = true;
        this.submissionMessage = "Appointment request sent successfully!";
        localStorage.setItem("lastAppointmentSubmit", now);

        this.form = {
          name: '',
          phone: '',
          email: '',
          date: '',
          message: ''
        };
      }, 2000);
    },
    openWhatsApp() {
      const phoneNumber = "918638940021";

      const message = `Hello Magnum Dental,

I'd like to book a dental appointment.

My Name:
Preferred appointment date:
Preferred appointment time:
Reason for Visit:`;

      const url =
        "https://wa.me/" +
        phoneNumber +
        "?text=" +
        encodeURIComponent(message);

      window.open(url, "_blank");
    }

  }
};
</script>


<style scoped>
.input {
  @apply border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400;
}
</style>
